export default {
  spec(state) {
    return state.spec
  }
}